import React from "react";
import PageHero from "../components/PageHero";
import DataFlowShowcase from "../components/DataFlowShowcase";
import ToolAnimations from "../components/ToolAnimations";
import Services from "../components/Services";
import Process from "../components/Process";
import Capabilities from "../components/Capabilities";
import Industries from "../components/Industries";
import FabricFocus from "../components/FabricFocus";
import Engagement from "../components/Engagement";
import Platforms from "../components/Platforms";

const ServicesPage = () => (
  <div>
    <PageHero
      eyebrow="Services"
      title="Everything V4 Data And AI Solutions delivers, in one place"
      subtitle="Services, process, capabilities and industry expertise — the complete picture of how V4 Data And AI Solutions modernizes enterprise data platforms end-to-end."
      breadcrumb={[{ label: "Home", to: "/" }, { label: "Services" }]}
    />
    <Services />
    <ToolAnimations />
    <DataFlowShowcase />
    <FabricFocus />
    <Process />
    <Capabilities />
    <Industries />
    <Engagement />
    <Platforms />
  </div>
);

export default ServicesPage;
